import createTheme from './createTheme'

const BLACK = '#47484A'

export const base = {
  colors: {
    main: '#F118A7',
    main90: '#f22fb0',
    main80: '#F551B9',
    main70: '#f55dc1',
    main60: '#f774ca',
    main50: '#F88BD3',
    main40: '#FAAEE0',
    main30: '#FCD1ED',
    main20: '#FBE0F1',
    main10: '#FAEFF6',

    darkMain: '#530539',
    darkMain90: '#7D0855',
    darkMain80: '#A70A71',
    darkMain70: '#C00F83',
    darkMain60: '#D81395',
    darkMain50: '#F118A7',
    darkMain40: '#F551B9',
    darkMain30: '#F88BD3',
    darkMain20: '#FAAEE0',
    darkMain10: '#FCD1ED',

    accent: '#2377BC',
    accent90: '#297DBF',
    accent80: '#2E83C1',
    accent70: '#2C90D0',
    accent60: '#2A9DDE',
    accent50: '#44ACE8',
    accent40: '#5EBCF1',
    accent30: '#78CBFB',
    accent20: '#C1E3FC',
    accent10: '#EAF6FC',

    accent_dark: '#001D65',
    accent_dark90: '#003893',
    accent_dark80: '#004FAC',
    accent_dark70: '#006FC6',
    accent_dark60: '#0086D4',
    accent_dark50: '#2A9DDE',
    accent_dark40: '#4CB6EB',
    accent_dark30: '#6ECFF9',
    accent_dark20: '#92DBFC',
    accent_dark10: '#B4E4FC',

    black: BLACK,

    gray: '#555759',
    gray90: '#6A6A6B',
    gray80: '#838384',
    gray70: '#919294',
    gray60: '#ABADB3',
    gray50: '#C5C6CA',
    gray40: '#D3D4D7',
    gray30: '#E2E2E3',
    gray20: '#E8E9EB',
    gray10: '#EFF1F4',

    leftMenuOpeBg: '#003893',

    focusColor: '#0140a8',
  },
  fontFamily: 'opensans',
  fontFaces: {
    opensans: [
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-light.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-light.woff',
            format: 'woff',
          },
        ],
        weight: 100,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-light.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-light.woff',
            format: 'woff',
          },
        ],
        weight: 200,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-regular.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-regular.woff',
            format: 'woff',
          },
        ],
        weight: 300,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-bold.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-bold.woff',
            format: 'woff',
          },
        ],
        weight: 400,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-book.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-book.woff',
            format: 'woff',
          },
        ],
        weight: 500,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-bold.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-bold.woff',
            format: 'woff',
          },
        ],
        weight: 700,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-extrabold.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/opensans/OpenSans-extrabold.woff',
            format: 'woff',
          },
        ],
        weight: 800,
        style: 'normal',
      },
    ],
  },
  components: {
    modal: {
      borderRadius: '4px 4px 40px 4px',
      title: {
        color: BLACK,
      },
    },
    button: {
      borderRadius: '40px',
      textTransform: 'uppercase',
      fontWeight: 'book',
      backgroundColor: 'darkMain60',
    },
    buttonBordered: {
      borderColor: 'darkMain70',
      color: 'darkMain70',
    },
    buttonUnstyled: {
      color: 'darkMain60',
    },
    input: {
      borderWidth: '0 0 1px 0',
      borderRadius: '0',
      focusColor: 'focusColor',
      fontSize: 'medium',
      fontWeight: 'regular',
      labelFontSize: 'xSmall',
      labelFontWeight: 'book',
    },
    simpleInput: {
      borderWidth: '0 0 1px 0',
      borderRadius: '0',
      focusColor: 'focusColor',
    },
    paginatorButton: {
      backgroundColor: 'accent',
      borderColor: 'accent',
      borderRadius: '20px',
      enabledBorderColor: 'transparent',
    },
    table: {
      headerBackgroundColor: 'accent10',
      accent: 'accent',
    },
    stepper: {
      main: 'accent_dark',
    },
    checks: {
      iconFilled: {
        disabledBackgroundColor: 'lightGray20',
        defaultBackgroundColor: 'white',
        disabledBorderColor: 'lightGray',
        defaultBorderColor: 'gray',
        iconColor: 'accent',
        defaultFontColor: 'gray',
      },
      checkedColor: 'accent',
    },
  },
}

export default createTheme(base)
